import { useQuery } from "@tanstack/react-query";
import { getBusinessQueueConfig } from "apis";
import { useMyAccessProfileV2 } from "./get-my-access-profile";
import { QUEUE_CONFIG_KEY } from "../../constants/config";
import { getCalendarConfigs } from "../../utils/bridges/methods";

export function getQueueConfigQueryKey({
  businessId,
}: { businessId?: string } = {}) {
  const queryArray: (string | boolean)[] = ["queue-config"];
  if (businessId) {
    queryArray.push(businessId);
  }
  return queryArray;
}

const useGetQueueConfig = () => {
  const { data: myAccessProfile } = useMyAccessProfileV2();
  const { business, doctors } = myAccessProfile || {};
  const { id: businessId = "" } = business || {};

  return useQuery(
    getQueueConfigQueryKey({
      businessId,
    }),
    async () => {
      const calendarConfigs = await getCalendarConfigs();

      return getBusinessQueueConfig({
        businessId,
        docIds: doctors?.map((doctor) => doctor.oid) || [],
        slot_config: !!calendarConfigs?.slotsFromDoctorCalendar,
      });
    },
    {
      staleTime: Infinity,
      enabled: !!businessId,
      placeholderData: () => {
        const queueConfig = localStorage.getItem(QUEUE_CONFIG_KEY);
        if (queueConfig) {
          return {
            success: true,
            data: JSON.parse(queueConfig),
          };
        }
      },
      onSuccess: (data) => {
        const { data: queueConfigs } = data;
        if (queueConfigs) {
          localStorage.setItem(QUEUE_CONFIG_KEY, JSON.stringify(queueConfigs));
        }
      },
    }
  );
};

export default useGetQueueConfig;
